import * as React from 'react';
import { translateService } from '../../services/TranslateService';
import Translate from 'react-translate-component';
import styles from "./main.module.scss";
import { cx } from './util';
import moment from 'moment';
import { Dialog, IconButton } from '@mui/material';
import { Card } from 'react-bootstrap';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { GlobalStore } from '../../reduxStore';
import VehicleSearch from '../VehicleSearch/VehicleSearch';
import CloseIcon from '@mui/icons-material/Close';
import dataContext, { DataContext } from '../../contexts/dataContext';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

interface PropsInterface {
    carId: number;
}
export default function ReservationTime({ carId }: PropsInterface) {
    const { searchParameters, changeSearchParameters, changeVehicle, vehicle, oneWayRes, loggedIn, reservationCreated, rootUrl } = React.useContext(DataContext);
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const [showChangeTimes, setShowChangeTimes] = React.useState<boolean>(false);
    const [showBusy, setShowBusy] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    let startD = moment(searchParameters?.startDate);
    let endD = moment(searchParameters?.endDate);

    const rentalDurationDiffInMinutes = endD.diff(startD, "minutes", true);
    const rentalDurationDays = parseInt((rentalDurationDiffInMinutes/(24*60)).toString()); // divide by minutes in a day + use int value for day count
    const minutesLeftAfterDaySubtract = rentalDurationDiffInMinutes%(24*60); // minutes after full days extracted
    const rentalDurationHours = parseInt((minutesLeftAfterDaySubtract/60).toString()); // minutes / 1 hour
    const rentalDurationMinutes = parseInt((minutesLeftAfterDaySubtract%60).toString());

    // get days, hours and minutes same method as rental duration above
    const resStartFromPresentInMinutes = startD.diff(moment(), "minutes", true);
    const reservationStartDays = parseInt((resStartFromPresentInMinutes/(24*60)).toString());
    const resMinutesLeftAfterDaySubtract = resStartFromPresentInMinutes%(24*60); // minutes after full days extracted
    const reservationStartHours = parseInt((resMinutesLeftAfterDaySubtract/60).toString());
    const reservationStartMinutes = parseInt((resMinutesLeftAfterDaySubtract%60).toString());

    const search = (p:any) => {
        setShowBusy(true);
        setErrorMsg("");
        let newparams = p(searchParameters);
        let mergeParams = { ...newparams, carId: carId };

        if (!oneWayRes) {
            apiService?.vehicle.searchWithParams(mergeParams)
                .then(r => {
                    if (r.count === 1) {
                        if (r.vehicles[0].availabilityData.available) {
                            changeVehicle(r.vehicles[0]);
                            changeSearchParameters(newparams);
                            closePopup();
                            return;
                        }
                    }
                    setErrorMsg(translateService.translate("vehicleSearch1.notAvailable"))
                })
                .catch(e => { console.log(e); setErrorMsg(translateService.translate('vehicleSearch.errorLoadingResults')); })
                .finally(() => setShowBusy(false));
        } else {
            apiService?.vehicle.oneWaySearchWithParams(mergeParams, loggedIn ?? false)
                .then(r => {
                    if (r.count === 1) {
                        if (r.vehicles[0].availabilityData.available) {
                            changeVehicle(r.vehicles[0]);
                            changeSearchParameters(newparams);
                            closePopup();
                            return;
                        }
                    }
                    setErrorMsg(translateService.translate("vehicleSearch1.notAvailable"))
                })
                .catch(e => { console.log(e); setErrorMsg(translateService.translate('vehicleSearch.errorLoadingResults')); })
                .finally(() => setShowBusy(false));
        }

    }
    const closePopup = () => {
        setErrorMsg("");
        setShowChangeTimes(false);
    }

    return <>
        <Dialog className='extension-modal' open={showChangeTimes} onClose={closePopup}>
            <IconButton
                aria-label="close"
                onClick={closePopup}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <VehicleSearch modifyReservation setSearchParams={search} setErrorMsg={setErrorMsg} clearResults={() => { }} />
            <Backdrop
                sx={{ color: '#fbb040', zIndex: (theme) => theme.zIndex.drawer + 10005  }}
                open={showBusy}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {!!errorMsg &&
                <Card className={`card-body mb-4`}>
                    <div className="text-center pt-3">{errorMsg}</div>
                </Card>}
        </Dialog>
        <div className={cx(styles.r24FullWidth, styles.greenBorderAround, styles.r24BottomMargin10)}>
            { oneWayRes ?
                <span className={styles.onewayResCreateDisclaimer}>

                    {translateService.translate("vehicleSearch.onewayResCreateDisclaimer1")}
                    {vehicle?.homeLocationData.fullAddress }
                    {translateService.translate('vehicleSearch.onewayResCreateDisclaimer2')} {vehicle?.returnLocationData?.fullAddress}.
                </span>
                : null }

            <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopBottomPadding5)}>

                <div className={cx(styles.r24ChildFlex1, styles.r24ReservationInfoRight)}>
                    <span className={styles.reservationInfo}>
                        <Translate content={'vehicleSearch.services.reservationDetails'} /> :
                    </span>
                </div>
                <div className={cx(styles.r24ChildFlex1, styles.r24ReservationInfoLeft)}>
                    <button onClick={() => setShowChangeTimes(true)} className={cx("btn btn-info btn-sm py-2 px-3")} disabled={reservationCreated}>
                        {translateService.translate('vehicleSearch.services.changeDates').toUpperCase()}
                    </button>
                </div>
            </div>
            <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopBottomPadding5)}>
                <div className={cx(styles.r24ChildFlex1, styles.r24ReservationInfoRight)}>
                    <img width="27" height="27" className={styles.timeIcons} src={rootUrl+'/assets/icons/new/reservation-details/icon-pickup-vehicle.svg'} alt="icon-pickup-vehicle.svg" loading="lazy"/>
                    <div className={styles.r24ReservationInfoText} >
                        <strong><Translate content={'vehicleSearch.services.pickup'} /> :</strong>
                        <br/>
                        <span className={styles.reservationDates}>{translateService.getWeekDay(searchParameters?.startDate ? moment(searchParameters.startDate).clone().format("DD.MM.YYYY") : '')} {moment(searchParameters?.startDate).clone().format('DD.MM.YYYY')} <Translate content={'vehicleSearch.services.at'} /> {searchParameters?.startTime?.toString()}</span>
                    </div>
                </div>
                <div className={cx(styles.r24ChildFlex1, styles.r24ReservationInfoLeft)}>
                <img width="27" height="27" className={styles.timeIcons} src={rootUrl+'/assets/icons/new/reservation-details/icon-return-vehicle.svg'} alt="icon-return-vehicle.svg" loading="lazy"/>
                    <i className='sprite icon-return-vehicle'></i>
                    <div className={styles.r24ReservationInfoText}>
                        <strong><Translate content={'vehicleSearch.services.dropoff'} /> :</strong>
                        <br />
                        <span className={styles.reservationDates}>
                            {translateService.getWeekDay(searchParameters?.endDate ? moment(searchParameters.endDate).clone().format("DD.MM.YYYY") : '')} {moment(searchParameters?.endDate).clone().format('DD.MM.YYYY')} <Translate content={'vehicleSearch.services.at'} /> {searchParameters?.endTime?.toString()}
                        </span>
                    </div>
                </div>
            </div>
            <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopPadding5)}>
                <div className={cx(styles.r24ChildFlex1, styles.r24ReservationInfoRight)}>
                <img width="27" height="27" className={styles.timeIcons} src={rootUrl+'/assets/icons/new/reservation-details/icon-duration.svg'} alt="icon-duration.svg" loading="lazy"/>
                    <div className={styles.r24ReservationInfoText}>
                        <strong><Translate content={'vehicleSearch.services.rentalduration'} /> :</strong>
                        <br />
                          <span className={styles.reservationDates}>{rentalDurationDays} <Translate content={'vehicleSearch.services.days'} /> {rentalDurationHours} h {rentalDurationMinutes} min</span>
                    </div>
                </div>
                <div className={cx(styles.r24ChildFlex1, styles.r24ReservationInfoLeft)}>
                <img width="27" height="27" className={styles.timeIcons} src={rootUrl+'/assets/icons/new/reservation-details/icon-reservation-start.svg'} alt="icon-reservation-start.svg" loading="lazy"/>
                    <div className={styles.r24ReservationInfoText}>
                        <strong><Translate content={'vehicleSearch.services.rentalstarts'} /> :</strong>
                        <br />
                        <span className={styles.reservationstarts}> {reservationStartDays} <Translate content={'vehicleSearch.services.days'} /> {reservationStartHours} h {reservationStartMinutes} min</span>
                    </div>
                </div>
            </div>
        </div>
    </>
}